import { CorporatePage, DefaultMeta } from '../../../types/partner-page-types';
import { ICalculatorList } from '../../Calculators/calculator-revamp/types';
import { FaqVariants } from '../../Common/FAQS';
import { LANGUAGE_DATA } from './language/types';

export interface CATEGORY_PROPS {
  id: number;
  name: string;
  slug: string;
  status: boolean;
  domain: number;
  parent: CATEGORY_PROPS | null;
}

export enum THEME {
  dark = 'dark',
  light = 'light',
}

export interface IAuthorDetails {
  id: number;
  name: string;
  description: string | null;
  status: boolean;
  designation: string | null;
  qualification: string | null;
  image_url: string | null;
  slug: string;
  linkedin_url: string | null;
  facebook_url: string | null;
  twitter_url: string | null;
  language: Array<number>;
  domain: Array<number>;
}

export interface IFAQ {
  id: number;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string | null;
  question: string;
  answer: string;
  status: boolean;
  category: number;
  language: number;
}

export interface ISINGLE_POST {
  id: number;
  category: CATEGORY_PROPS;
  domain: number;
  related_posts: Array<IRELATED_POSTS> | null;
  popular_posts: Array<IRELATED_POSTS> | null;
  interesting_posts: Array<IRELATED_POSTS> | null;
  author_details: IAuthorDetails;
  linked_languages: Array<{ language_id: number; language_name: string }> | [];
  title: string;
  content_summary?: string;
  content: string;
  content_type?: string;
  layout: string;
  status: string;
  permalink: string;
  created_at: string;
  updated_at: string;
  meta_title: string;
  description: string;
  keywords: string;
  page_type: string;
  created_by: string | null;
  updated_by: string;
  no_index: boolean;
  multi_language: boolean;
  alt_permalink: string | null;
  notes: string;
  show_author: boolean;
  sitemap_priority: string;
  author: number;
  language: number;
  alt_language: number | null;
  cta: string | null;
  faq: IFAQ[];
  isCalculator?: boolean;
  calculatorData?: ICalculatorList;
}

export interface PostData {
  data: ISINGLE_POST;
}

export interface ISTATIC_PAGE_PROPS {
  postData: PostData | CorporatePage;
  metaData?: DefaultMeta | Record<string, unknown>;
  pageType?: 'CMS' | 'partner' | 'glossary' | 'calculator' | '';
}

export interface GLOSSARY_PAGE_PROPS {
  postData: PostData;
  metaData?: DefaultMeta | Record<string, unknown>;
}

export interface ITOC {
  content?: HTMLDivElement | null;
  language: keyof LANGUAGE_DATA;
  variant?: FaqVariants;
  showToCIcon?: boolean;
  tocIndexList: Array<{ id: string; content: string }>;
  dom?: HTMLElement | null;
}

export interface ISOCIAL_MEDIA {
  linkedin?: string | null;
  facebook?: string | null;
  twitter?: string | null;
  whatsapp?: string | null;
}

export interface IRELATED_POSTS {
  title: string;
  permalink: string;
}

export interface IMATRIX_PROPS {
  parentCategory: string;
  category?: string;
  action?: string;
}

export interface T_ARTICLE_PROPS {
  articleData: {
    title: string;
    updated_at: string;
    permalink: string;
    content: string;
    related_posts: Array<IRELATED_POSTS> | null;
    popular_posts: Array<IRELATED_POSTS> | null;
    interesting_posts: Array<IRELATED_POSTS> | null;
    language: number;
    domain: number;
  };
}
